import React from 'react';
import { bonuses } from '../data/bonuses';
import { OFFER_ANCHOR } from './constants';
export function BonusSection() {
  return <section className="border-y border-golf-line bg-golf-light px-4 py-4" data-id="element-16" data-mp="1ofc5fttsurgy">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="22fwlwjc8sb7a">
        <div className="mb-2 text-center" data-id="element-18" data-mp="22div4molhl5j">
          <h2 className="mb-1 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-19" data-mp="1ydi8wfv985nx">
            🎁 5 Premium Bonuses Included
          </h2>
          <p className="mx-auto max-w-3xl text-[13px] font-medium leading-snug text-golf-muted sm:text-base" data-id="element-20" data-mp="15pcmloojy8lz">
            Five additional professional resources to make your coaching system even more complete.
          </p>
        </div>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="1eozn889gjadz">
          {bonuses.map(bonus => <a key={bonus.title} href={OFFER_ANCHOR} className="rounded-lg border border-golf-gold/70 bg-white p-3 shadow-sm transition-colors duration-150 ease-out hover:border-golf-lime" data-id="element-22" data-mp="qzohecd92psz">
              <h3 className="font-head text-[14px] font-bold leading-tight text-golf-green sm:text-lg" data-id="element-23" data-mp="29q0et16sc89m">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium leading-snug text-golf-muted sm:text-sm" data-id="element-24" data-mp="2jhmm4mg05n73">
                {bonus.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}